// src/components/product/BundleEditor/BundleSkuFields.jsx
import React from 'react';
import { Hash, Loader2 } from 'lucide-react';
import { useLocalization } from '../../../contexts/LocalizationContext';
import styles from '../../../pages/products/CreateProductPage/styles/PricingTab.module.css';

const BundleSkuFields = ({ formData, errors = {}, skuValidation, handleInputChange }) => {
  const { t } = useLocalization();

  return (
    <div className={styles.formCard}>
      <div className={styles.cardHeader}>
        <h2>{t('products.basicInfo')}</h2>
      </div>
      <div className={styles.cardContent}>
        <div className={styles.formRow}>
          <div className={styles.formGroup}>
            <label htmlFor="sku">{t('products.sku')}</label>
            <div className={styles.inputWithIcon}>
              <Hash size={18} className={styles.inputIcon} />
              <input
                type="text"
                id="sku"
                name="sku"
                value={formData.sku || ''}
                onChange={handleInputChange}
                placeholder={t('products.skuPlaceholder')}
                className={errors.sku ? 'error' : ''}
              />
              {skuValidation?.mainSku?.isValidating && (
                <Loader2 size={16} className={`${styles.inputIcon} ${styles.validationSpinner}`} />
              )}
            </div>
            {errors.sku && <span className={styles.errorText}>{errors.sku}</span>}
          </div>

          <div className={styles.formGroup}>
            <label htmlFor="barcode">{t('products.barcode')}</label>
            <div className={styles.inputWithIcon}>
              <Hash size={18} className={styles.inputIcon} />
              <input
                type="text"
                id="barcode"
                name="barcode"
                value={formData.barcode || ''}
                onChange={handleInputChange}
                placeholder={t('products.barcodePlaceholder')}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BundleSkuFields;
